import { api } from './authService';

export const channelsService = {
  // Получить канал по ID
  getChannel: async (id) => {
    const response = await api.get(`/channels/${id}`);
    return response.data;
  },
  
  // Создать новый канал
  createChannel: async (data) => {
    const response = await api.post('/channels', data);
    return response.data;
  },
  
  // Получить сообщения канала
  getMessages: async (channelId, limit = 10, beforeId = null) => {
    const params = new URLSearchParams();
    params.append('limit', limit);
    if (beforeId) {
      params.append('beforeId', beforeId);
    }
    const response = await api.get(`/channels/${channelId}/messages?${params.toString()}`);
    return response.data;
  },
  
  // Отправить сообщение
  sendMessage: async (channelId, data) => {
    const response = await api.post(`/channels/${channelId}/messages`, data);
    return response.data;
  },
  // Создать новый канал
  createChannel: async (data) => {
    const response = await api.post('/channels', data);
    return response.data;
  },

  // Создать новый канал
  createChannel: async (data) => {
    const response = await api.post('/channels', data);
    return response.data;
  },

  // Обновить канал
  updateChannel: async (channelId, data) => {
    const response = await api.put(`/channels/${channelId}`, data);
    return response.data;
  },  

  // Удалить канал
  deleteChannel: async (channelId) => {
      const response = await api.delete(`/channels/${channelId}`);
      return response.data;
  },
  
   // Создать личный канал
   createPrivateChannel: async (channelName, userId1, userId2) => {
    const response = await api.post('/channels/private', { 
      name: channelName, 
      userId1, 
      userId2 
    });
    return response.data;
  },

  // Получить список личных каналов текущего пользователя
  getPrivateChannels: async () => {
    const response = await api.get('/channels/private');
    return response.data;
  },

  //Получить активных участников канала
  getActiveChannelMembers: async (channelId) => {
    const response = await api.get(`/channels/${channelId}/members`);
    return response.data;
  },

  getAllChannelMembers: async (channelId) => {
    const response = await api.get(`/channels/${channelId}/allmembers`);
    return response.data;
  },

  getMessagesWithRead: async (channelId, limit = 10, beforeId = null) => {
    const params = new URLSearchParams();
    params.append('limit', limit);
    if (beforeId) {
      params.append('beforeId', beforeId);
    }
    const response = await api.get(`/channels/${channelId}/messages-with-read?${params.toString()}`);
    return response.data;
  },

  searchMessages: async (channelId, query) => {
    const response = await api.get(`/channels/${channelId}/search?query=${encodeURIComponent(query)}`);
    return response.data;
  },

  getChannelImages: async (channelId) => {
    const response = await api.get(`/channels/${channelId}/images`);
    return response.data;
  },
};